import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Container } from "@mui/material";
import Button from "@mui/material/Button";
import CurrencyField from "./CurrencyField";

export default class InputForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.results = props.results;

    this.state = {
      inflationRate: 0.03,
      yearlyExpenses: 140_000,
      ageOfFullRetirement: 60,
      numberOfTrials: 10,
      investmentBalance: 1_550_000,
      retirementBalance: 230_000,
      startAge: 36,
      endAge: 99,
      taxRate: 0.1,
      income: 40_000,
      incomeIncreaseRate: 0.02,
      showAdvancedFields: false,
      mgkPrice: 222.39,
      schdPrice: 70.16,
      mgkDividendPerShare: 1.24,
      schdDividendPerShare: 2.64,
      mgkDividendGrowthRate: 0.03,
      schdDividendGrowthRate: 0.10,
    };

    this.mgkReturns = [
      -0.3359, 0.2858, 0.4099, 0.3739, -0.029, 0.2949, 0.0654, 0.0364, 0.1361,
      0.3259, 0.1723, 0.0309, 0.1451, 0.3501, -0.3625,
    ];

    this.schdReturns = [
      -0.0323, 0.2987, 0.1508, 0.2728, -0.0556, 0.2083, 0.1644, -0.031, 0.1169,
      0.3289, 0.1139, 0.0292, 0.1043, 0.1001, -0.2212,
    ];
  }

  render() {
    let advancedFields = undefined;

    if(this.state.showAdvancedFields){
      advancedFields = this.advancedFields();
    }

    return (
      <Container
        style={{
          minWidth: "100%",
        }}
      >
        <Box component="form" noValidate sx={{ mt: 3 }}>
          <Grid container spacing={2}>
            <Grid sx={{ p: 1 }} item xs={6}>
              <TextField
                label="Inflation Rate"
                variant="outlined"
                defaultValue={this.state.inflationRate}
                onChange={(event) => {
                  this.setState({
                    inflationRate: parseFloat(
                      event.target.value.replace(/,/g, "")
                    ),
                  });
                }}
              />
            </Grid>
            <Grid sx={{ p: 1 }} item xs={6}>
              <CurrencyField
                label="Investment Balance"
                variant="outlined"
                defaultValue={this.state.investmentBalance}
                onChange={(event) => {
                  this.setState({
                    investmentBalance: parseFloat(
                      event.target.value.replace(/,/g, "")
                    ),
                  });
                }}
              />
            </Grid>
            <Grid sx={{ p: 1 }} item xs={6}>
              <CurrencyField
                label="Yearly Expenses"
                variant="outlined"
                defaultValue={this.state.yearlyExpenses}
                onChange={(event) => {
                  this.setState({
                    yearlyExpenses: parseFloat(
                      event.target.value.replace(/,/g, "")
                    ),
                  });
                }}
              />
            </Grid>
            <Grid sx={{ p: 1 }} item xs={6}>
              <TextField
                label="Start Age"
                variant="outlined"
                defaultValue={this.state.startAge}
                onChange={(event) => {
                  this.setState({
                    startAge: parseFloat(event.target.value.replace(/,/g, "")),
                  });
                }}
              />
            </Grid>
            <Grid sx={{ p: 1 }} item xs={6}>
              <TextField
                label="End Age"
                variant="outlined"
                defaultValue={this.state.endAge}
                onChange={(event) => {
                  this.setState({
                    endAge: parseFloat(event.target.value.replace(/,/g, "")),
                  });
                }}
              />
            </Grid>
            <Grid sx={{ p: 1 }} item xs={6}>
              <TextField
                label="Age of Full Retirement"
                variant="outlined"
                defaultValue={this.state.ageOfFullRetirement}
                onChange={(event) => {
                  this.setState({
                    ageOfFullRetirement: parseFloat(
                      event.target.value.replace(/,/g, "")
                    ),
                  });
                }}
              />
            </Grid>
            <Grid sx={{ p: 1 }} item xs={6}>
              <CurrencyField
                label="Retirement Balance"
                variant="outlined"
                defaultValue={this.state.retirementBalance}
                onChange={(event) => {
                  this.setState({
                    retirementBalance: parseFloat(
                      event.target.value.replace(/,/g, "")
                    ),
                  });
                }}
              />
            </Grid>
            <Grid sx={{ p: 1 }} item xs={6}>
              <TextField
                label="Marginal Tax Rate"
                variant="outlined"
                defaultValue={this.state.taxRate}
                onChange={(event) => {
                  this.setState({
                    taxRate: parseFloat(event.target.value.replace(/,/g, "")),
                  });
                }}
              />
            </Grid>
            <Grid sx={{ p: 1 }} item xs={6}>
              <CurrencyField
                label="Income"
                variant="outlined"
                defaultValue={this.state.income}
                onChange={(event) => {
                  this.setState({
                    income: parseFloat(event.target.value.replace(/,/g, "")),
                  });
                }}
              />
            </Grid>
            <Grid sx={{ p: 1 }} item xs={6}>
              <CurrencyField
                label="Income Increase Rate"
                variant="outlined"
                defaultValue={this.state.incomeIncreaseRate}
                onChange={(event) => {
                  this.setState({
                    incomeIncreaseRate: parseFloat(
                      event.target.value.replace(/,/g, "")
                    ),
                  });
                }}
              />
            </Grid>
            <Grid sx={{ p: 1 }} item xs={6}>
              <TextField
                label="# of Trials"
                variant="outlined"
                defaultValue={this.state.numberOfTrials}
                onChange={(event) => {
                  this.setState({
                    numberOfTrials: parseFloat(
                      event.target.value.replace(/,/g, "")
                    ),
                  });
                }}
              />
            </Grid>
          </Grid>
          <hr></hr>
          <span>Advanced Fields </span>{" "}
          <a href="" onClick={this.toggleAdvancedFields.bind(this)}>
            {this.state.showAdvancedFields ? "Hide" : "Show"}
          </a>

          {advancedFields}
          <hr></hr>
         
          <Button variant="outlined" onClick={this.runSimulation.bind(this)}>
            Run Simulation
          </Button>
        </Box>
      </Container>
    );
  }

  advancedFields() {
    return (
      <Grid container spacing={2}>
        <Grid sx={{ p: 1 }} item xs={6}>
              <CurrencyField
                label="MGK Price"
                variant="outlined"
                defaultValue={this.state.mgkPrice}
                onChange={(event) => {
                  this.setState({
                    mgkPrice: parseFloat(
                      event.target.value.replace(/,/g, "")
                    ),
                  });
                }}
              />
            </Grid>

            <Grid sx={{ p: 1 }} item xs={6}>
              <CurrencyField
                label="SCHD Price"
                variant="outlined"
                defaultValue={this.state.schdPrice}
                onChange={(event) => {
                  this.setState({
                    schdPrice: parseFloat(
                      event.target.value.replace(/,/g, "")
                    ),
                  });
                }}
              />
            </Grid>

            <Grid sx={{ p: 1 }} item xs={6}>
              <CurrencyField
                label="MGK Dividend Per Share"
                variant="outlined"
                defaultValue={this.state.mgkDividendPerShare}
                onChange={(event) => {
                  this.setState({
                    mgkDividendPerShare: parseFloat(
                      event.target.value.replace(/,/g, "")
                    ),
                  });
                }}
              />
            </Grid>

            <Grid sx={{ p: 1 }} item xs={6}>
              <CurrencyField
                label="SCHD Dividend Per Share"
                variant="outlined"
                defaultValue={this.state.schdDividendPerShare}
                onChange={(event) => {
                  this.setState({
                    schdDividendPerShare: parseFloat(
                      event.target.value.replace(/,/g, "")
                    ),
                  });
                }}
              />
            </Grid>

            <Grid sx={{ p: 1 }} item xs={6}>
              <TextField
                label="MGK Dividend Growth Rate"
                variant="outlined"
                defaultValue={this.state.mgkDividendGrowthRate}
                onChange={(event) => {
                  this.setState({
                    mgkDividendGrowthRate: parseFloat(event.target.value.replace(/,/g, "")),
                  });
                }}
              />
            </Grid>

            <Grid sx={{ p: 1 }} item xs={6}>
              <TextField
                label="SCHD Dividend Growth Rate"
                variant="outlined"
                defaultValue={this.state.schdDividendGrowthRate}
                onChange={(event) => {
                  this.setState({
                    schdDividendGrowthRate: parseFloat(event.target.value.replace(/,/g, "")),
                  });
                }}
              />
            </Grid>
      </Grid>
    );
  }

  runSimulation() {
    this.results = [];

    const SCHD_WEIGHT = 0.8;
    const MGK_WEIGHT = 0.2;

    for (var x = 0; x < this.state.numberOfTrials; x++) {
      let successful = true;

      let investmentBalance = this.state.investmentBalance;

      let mgkPrice = this.state.mgkPrice;
      let schdPrice = this.state.schdPrice;
      let yearlyExpenses = this.state.yearlyExpenses;
      let startAge = this.state.startAge;
      let endAge = this.state.endAge;
      let income = this.state.income;
      let retirementBalance = this.state.retirementBalance;
      let schdDividendPerShare = this.state.schdDividendPerShare;
      let mgkDividendPerShare = this.state.mgkDividendPerShare;
      let schdDividendGrowthRate = this.state.schdDividendGrowthRate;
      let mgkDividendGrowthRate = this.state.mgkDividendGrowthRate;

      let trialResults = [];
      let returns = [];

      let mgkBalance = investmentBalance * MGK_WEIGHT;
      let schdBalance = investmentBalance * SCHD_WEIGHT;

      let schdShares = (investmentBalance * SCHD_WEIGHT) / schdPrice;
      let mgkShares = (investmentBalance * MGK_WEIGHT) / mgkPrice;

      while (startAge < endAge) {
        let taxes = 0;

        if (startAge === this.state.ageOfFullRetirement) {
          schdBalance += retirementBalance;
          schdShares += schdBalance / schdPrice;
        }

        let schdAvgReturn =
          this.schdReturns[Math.floor(Math.random() * this.schdReturns.length)];

        let mgkAvgReturn =
          this.schdReturns[Math.floor(Math.random() * this.schdReturns.length)];

        let schdReturnAmt = 0;
        if (schdBalance > 0) {
          schdReturnAmt = schdAvgReturn * schdBalance;
          schdBalance = schdReturnAmt + schdBalance;
        }

        let mgkReturnAmt = 0;
        if (mgkBalance > 0) {
          mgkReturnAmt = mgkAvgReturn * mgkBalance;
          mgkBalance = mgkReturnAmt + mgkBalance;
        }

        yearlyExpenses =
          yearlyExpenses + yearlyExpenses * this.state.inflationRate;

        if (startAge < this.state.ageOfFullRetirement)
          retirementBalance =
            retirementBalance + retirementBalance * mgkAvgReturn;

        taxes = income * this.state.taxRate;

        let dividends =
          mgkShares * mgkDividendPerShare + schdShares * schdDividendPerShare;

        let netIncome = dividends + (income - taxes);

        let withdrawAmount = yearlyExpenses - netIncome;

        let incomeOverExpenses = 0;
        if (withdrawAmount > 0) {
          let withdrawTaxes = withdrawAmount * this.state.taxRate;
          taxes += withdrawTaxes;
          withdrawAmount += withdrawTaxes;

          let schdWithdrawAmt = 0;
          let mgkWithdrawAmt = 0;

          if (mgkBalance <= 0) {
            schdWithdrawAmt = withdrawAmount;
            schdShares -= schdWithdrawAmt / schdPrice;
            schdBalance -= schdWithdrawAmt;
            if (schdShares <= 0) {
              schdBalance = 0;
              schdShares = 0;
            }
            mgkShares = 0;
          } else if (schdBalance <= 0) {
            mgkWithdrawAmt = withdrawAmount;
            mgkShares -= mgkWithdrawAmt / mgkPrice;
            mgkBalance -= mgkWithdrawAmt;
            if (mgkShares <= 0) {
              mgkBalance = 0;
              mgkShares = 0;
            }
            schdShares = 0;
          } else if (mgkBalance <= withdrawAmount * MGK_WEIGHT) {
            let schdWithdrawAmt = withdrawAmount - mgkBalance;
            mgkShares = 0;
            mgkBalance = 0;
            schdBalance -= schdWithdrawAmt;
            schdShares -= schdWithdrawAmt / schdPrice;
          } else if (schdBalance <= withdrawAmount * SCHD_WEIGHT) {
            mgkWithdrawAmt -= withdrawAmount - schdBalance;
            schdShares = 0;
            schdBalance = 0;
            mgkBalance -= mgkWithdrawAmt;
            mgkShares -= mgkWithdrawAmt / mgkPrice;
          } else {
            schdWithdrawAmt = withdrawAmount * SCHD_WEIGHT;
            mgkWithdrawAmt = withdrawAmount * MGK_WEIGHT;
            schdShares -= schdWithdrawAmt / schdPrice;
            mgkShares -= mgkWithdrawAmt / mgkPrice;

            mgkBalance -= mgkWithdrawAmt;
            schdBalance -= schdWithdrawAmt;

            if (schdShares < 0 || schdBalance < 0) {
              schdShares = 0;
              schdBalance = 0;
            }

            if (mgkShares < 0 || mgkBalance < 0) {
              mgkShares = 0;
              mgkBalance = 0;
            }
          }
        } else {
          incomeOverExpenses += 0 - withdrawAmount;
          withdrawAmount = 0;
        }

        if (
          mgkBalance <= 0 &&
          schdBalance <= 0 &&
          schdShares <= 0 &&
          mgkShares <= 0
        ) {
          successful = false;
          break;
        }

        trialResults.push({
          id: `${x}:${startAge}`,
          successful: successful,
          age: startAge,
          schdInvestmentReturn: schdAvgReturn * 100,
          mgkInvestmentReturn: mgkAvgReturn * 100,
          schdInvestmentReturns: schdReturnAmt,
          mgkInvestmentReturns: mgkReturnAmt,
          incomeOverExpenses: incomeOverExpenses,
          netIncome,
          investmentWithdraw: withdrawAmount,
          investmentBalance: mgkBalance + schdBalance,
          yearlyExpenses,
          taxes,
          schdShares,
          mgkShares,
          dividends,
          mgkDividendPerShare,
          schdDividendPerShare,
          mgkPrice,
          schdPrice,
        });

        startAge += 1;

        mgkDividendPerShare += mgkDividendPerShare * mgkDividendGrowthRate;
        schdDividendPerShare +=
          schdDividendPerShare * schdDividendGrowthRate;
        income += income * this.state.incomeIncreaseRate;

        schdPrice += schdPrice * schdAvgReturn;
        mgkPrice += mgkPrice * mgkAvgReturn;

        returns.push((schdAvgReturn + mgkAvgReturn) / 2);
      }

      this.results.push({
        trial: x,
        successful: successful,
        results: trialResults,
        retirementBalance: retirementBalance,
        avgReturn:
          returns.reduce((partialSum, a) => partialSum + a, 0) / returns.length,
      });
    }

    this.handleChange();
  }

  handleChange(e) {
    this.props.onResultsChange(this.results);
  }

  toggleAdvancedFields(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ showAdvancedFields: !this.state.showAdvancedFields });
  }
}
